import { deleteRequest, getRequest, postRequest, putRequest } from '.'
import CharacterClass from 'app/frontend/types/custom/CharacterClass'
import CharacterRole from 'app/frontend/types/custom/CharacterRole'

export type GuildCandidatesResponse = {
  candidates: wowaudit.GuildCandidate[]
}

export type NewGuildCandidateInput = {
  name: string
  surname: string
  characterClass: CharacterClass
  specId?: number
  role?: CharacterRole
}

export type GuildCandidateInput =
  | NewGuildCandidateInput
  | { characterId: number; specId?: number; role?: CharacterRole }

export const getGuildCandidates = async (
  guildId: number,
): Promise<GuildCandidatesResponse> => {
  return await getRequest(`/api/guilds/${guildId}/candidates`)
}

export const addGuildCandidate = async (
  guildId: number,
  candidate: GuildCandidateInput,
): Promise<GuildCandidatesResponse> => {
  return await postRequest(`/api/guilds/${guildId}/candidates`, candidate)
}

export type GuildCandidateUpdate = {
  status?: wowaudit.GuildCandidate['status']
  comment?: string
  name?: string
  surname?: string
  characterClass?: CharacterClass
  specId?: number | null
  role?: CharacterRole
}

export const addManualGuildCandidate = async (
  guildId: number,
  candidate: NewGuildCandidateInput,
): Promise<GuildCandidatesResponse> => {
  return await postRequest(
    `/api/guilds/${guildId}/candidates/manual`,
    candidate,
  )
}

export const updateGuildCandidate = async (
  guildId: number,
  characterId: number,
  attributes: GuildCandidateUpdate,
): Promise<GuildCandidatesResponse> => {
  return await putRequest(
    `/api/guilds/${guildId}/candidates/${characterId}`,
    attributes,
  )
}

export const removeGuildCandidate = async (
  guildId: number,
  characterId: number,
): Promise<GuildCandidatesResponse> => {
  return await deleteRequest(`/api/guilds/${guildId}/candidates/${characterId}`)
}

export const setGuildCandidateTeams = async (
  guildId: number,
  characterId: number,
  teamIds: number[],
): Promise<GuildCandidatesResponse> => {
  return await putRequest(
    `/api/guilds/${guildId}/candidates/${characterId}/teams`,
    { teamIds },
  )
}

export const addAllCandidatesToTeam = async (
  guildId: number,
  teamId: number,
): Promise<GuildCandidatesResponse> => {
  return await putRequest(`/api/guilds/${guildId}/candidates/add_all_to_team`, {
    teamId,
  })
}
